const MODAL_ID = "reel-modal"

function modalElements() {
  const modal = document.getElementById(MODAL_ID)
  if (!modal) return null

  return {
    modal,
    source: modal.querySelector("[data-reels-viewer-target='source']"),
    video: modal.querySelector("[data-reels-viewer-target='video']"),
    caption: modal.querySelector("[data-reels-viewer-target='caption']"),
    userName: modal.querySelector("[data-reels-viewer-target='userName']"),
    userAvatar: modal.querySelector("[data-reels-viewer-target='userAvatar']"),
    profileLink: modal.querySelector("[data-reels-viewer-target='profileLink']"),
    serviceLink: modal.querySelector("[data-reels-viewer-target='serviceLink']"),
    serviceTitle: modal.querySelector("[data-reels-viewer-target='serviceTitle']"),
    linkedServiceContainer: document.getElementById("reel-linked-service")
  }
}

export function pauseHighlightPreview(reel) {
  const video = reel?.querySelector("video")
  if (!video) return

  video.pause()
  video.currentTime = 0
}

function toggleScrollLock(lock, force = false) {
  const body = document.body
  const html = document.documentElement
  let openModals = parseInt(body.dataset.openModals || "0", 10)

  if (lock) {
    openModals += 1
    body.dataset.openModals = openModals

    if (openModals === 1) {
      body.dataset.scrollLockY = String(window.pageYOffset)
      body.style.position = "fixed"
      body.style.top = `-${window.pageYOffset}px`
      body.style.width = "100%"
      body.classList.add("overflow-hidden")
      html.classList.add("overflow-hidden")
    }
  } else {
    openModals = force ? 0 : Math.max(0, openModals - 1)
    body.dataset.openModals = openModals

    if (openModals === 0) {
      const scrollY = body.dataset.scrollLockY || "0"
      body.style.position = ""
      body.style.top = ""
      body.style.width = ""
      body.classList.remove("overflow-hidden")
      html.classList.remove("overflow-hidden")
      delete body.dataset.scrollLockY
      if (!force) {
        window.scrollTo(0, parseInt(scrollY, 10))
      }
    }
  }
}

export function openHighlightModal(reel) {
  if (!reel?.dataset?.highlightId) return false

  pauseHighlightPreview(reel)

  const els = modalElements()
  if (!els?.modal || !els.source || !els.video) return false

  const {
    videoUrl,
    caption,
    userName,
    userAvatar,
    userProfileUrl,
    highlightId,
    linkedServiceId,
    linkedServiceTitle,
    linkedServiceUrl
  } = reel.dataset

  els.modal.dataset.activeId = highlightId
  els.source.src = videoUrl
  els.source.type = reel.querySelector("video source")?.type || "video/mp4"
  els.video.load()
  els.video.play().catch(() => {})

  if (els.caption) els.caption.textContent = caption || ""
  if (els.userName) els.userName.textContent = userName || ""

  if (els.userAvatar) {
    if (userAvatar) {
      els.userAvatar.src = userAvatar
      els.userAvatar.classList.remove("hidden")
    } else {
      els.userAvatar.classList.add("hidden")
    }
  }

  if (els.profileLink) els.profileLink.href = userProfileUrl || "#"

  const captionContainer = document.getElementById("reel-caption-panel")

  if (els.linkedServiceContainer) {
    if (linkedServiceId && linkedServiceTitle && linkedServiceUrl) {
      els.linkedServiceContainer.classList.remove("hidden")
      if (els.serviceLink) els.serviceLink.href = linkedServiceUrl
      if (els.serviceTitle) els.serviceTitle.textContent = linkedServiceTitle
      captionContainer?.classList.add("hidden")
    } else {
      els.linkedServiceContainer.classList.add("hidden")
      if (caption && els.caption) {
        captionContainer?.classList.remove("hidden")
        els.caption.textContent = caption
      } else {
        captionContainer?.classList.add("hidden")
      }
    }
  }

  els.modal.classList.remove("hidden")
  els.modal.classList.add("flex")
  toggleScrollLock(true)
  return true
}

export function closeHighlightModal() {
  const els = modalElements()
  if (!els?.modal) return

  if (els.video) els.video.pause()
  if (els.source) els.source.src = ""

  els.modal.classList.add("hidden")
  els.modal.classList.remove("flex")
  toggleScrollLock(false)
}
